import { makeStyles } from '@material-ui/styles'
import { colors } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  formAdicionarExame: {
    padding: '10px',
  },
  mainModal: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  camposFormulario: {
    overflow: 'auto',
    maxHeight: '600px',
  },
  botoesFormulario: {
    marginTop: '20px',
  },
  titulo: {
    borderBottom: 'thin solid #DDD',
  },
  formQuestionario: {
    paddingRight: 0,
    paddingLeft: 0,
    marginLeft: 0,
    marginRight: 0,
  },
}))

export default useStyles
